var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3425 10.7465H6.23145",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78613 7.1908V14.3019",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1648 2.44714H5.63155C4.78703 2.44714 3.97709 2.78262 3.37993 3.3798C2.78275 3.97697 2.44727 4.78691 2.44727 5.63143V19.2306C2.44727 20.1082 3.49687 20.5601 4.13442 19.9571L6.02959 18.1646L8.92476 20.9029C9.31029 21.2676 9.91352 21.2676 10.2991 20.9029L13.1942 18.1646L15.0894 19.9571C15.727 20.5601 16.7766 20.1082 16.7766 19.2306V4.83536C16.7766 4.20197 17.0281 3.59451 17.476 3.14664C17.9238 2.69877 18.5314 2.44714 19.1648 2.44714ZM19.1648 2.44714C19.7981 2.44714 20.4057 2.69877 20.8536 3.14664C21.3014 3.59451 21.553 4.20197 21.553 4.83536V7.81571C21.553 8.368 21.1053 8.81571 20.553 8.81571H16.7766",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillIcon);
export default __webpack_public_path__ + "static/media/billIcon.e07caab2fa236e33b6f567b60e9a88ff.svg";
export { ForwardRef as ReactComponent };